<template>
  <div
    class="header"
    :class="{ 'toggle-active': foldingMenu }"
    @mouseleave="selectLang = false"
    v-show="!isFullScreen"
  >
    <!-- web header -->
    <section class="web-header-wrapper">
      <!-- <section class="banner-flow">
        <div class="banner-wrap banner-1">
          <h6
            v-for="item in bannerList"
            :key="item"
            class="highlight"
            v-html="item.live_content"
          ></h6>
        </div>
        <div class="banner-wrap banner-2">
          <h6
            v-for="item in bannerList"
            :key="item + '_duplicate'"
            class="highlight"
            v-html="item.live_content"
          ></h6>
        </div>
      </section> -->

      <div class="menu-container">
        <!-- <ClientOnly> -->
        <div v-for="mainMenu in mainMenuRef" :key="mainMenu" class="sub-menu">
          <Swiper
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            class="sub-menu-list"
            :slides-per-view="8"
            :space-between="60"
            :breakpoints="{
              1024: {
                slidesPerView: 3,
              },
              1440: {
                slidesPerView: 5,
              },
            }"
          >
            <template v-if="mainMenu.isActive">
              <SwiperSlide
                v-for="submenu in mainMenu.subMenu"
                :key="submenu"
                class="highlight medium swiper-slide"
                @click="menuClickHandler(submenu)"
              >
                <span v-if="submenu.isActive" class="submenu-icon"
                  ><img :src="submenu.activeIcon" alt=""
                /></span>
                <span v-else class="submenu-icon" :class="submenu.key"
                  ><img :src="submenu.icon" alt=""
                /></span>
                <span
                  class="submenu-label"
                  :class="[
                    !submenu.beta ? 'disable-menu' : '',
                    submenu.isActive ? 'menu-active' : '',
                  ]"
                >
                  <template v-if="submenu.key === 'kibotZoneList'">
                    1% {{ $t(submenu.label) }}
                  </template>
                  <template v-else>
                    {{ $t(submenu.label) }}
                  </template>
                </span>
              </SwiperSlide>
            </template>
          </Swiper>
        </div>
        <!-- </ClientOnly> -->

        <!-- <div class="setting-menu">
                    <ul class="setting-menu-list">
                        <li
                            v-for="setting in settingMenuData" :key="setting"
                            @click="menuClickHandler(setting)"
                            @mouseenter="hoverHandler('enter', setting)"
                            @mouseleave="hoverHandler('leave', setting)"
                        >
                            <img
                                v-if="setting.key === 'store' && setting.isActive"
                                :src="menuHover[setting.key] ? setting.changeActiveIcon : setting.changeIcon"
                                v-tooltip.top-start="setting?.tooltipMsg"
                            />
                            <img
                                v-if="setting.key === 'store' && !setting.isActive"
                                :src="menuHover[setting.key] ? setting.activeIcon : setting.icon"
                                v-tooltip.top-start="'Store Dashboard'"
                            />
                            <img
                                v-if="setting.key !== 'store'"
                                :src="setting.isActive || menuHover[setting.key] ? setting.activeIcon : setting.icon"
                                v-tooltip.top-start="setting?.tooltipMsg"
                            />
                        </li>
                    </ul>
                </div> -->

        <div class="section-line"></div>

        <div class="extra-menu">
          <!-- <div class="referrals-list">
                        <img
                            :src="referralActive ? ReferralsActive : Referrals" alt=""
                            @click="selectReferrals()"
                            @mouseenter="referralActive = true"
                            @mouseleave="referralActive = false"
                            v-tooltip.top-start="'Referral Code'"
                        >
                        <transition name="fade">
                            <span class="copy-toast sentence sentence__600" v-if="showToast">
                                Referral copied
                            </span>
                        </transition>
                    </div> -->

          <div class="account__global">
            <img
              @click="selectLang = !selectLang"
              :src="globalImg"
              alt=""
              v-tooltip.top-start="'Language'"
            />

            <div class="account__global-select" v-if="selectLang">
              <div
                v-for="lang in globalMenu"
                :key="lang"
                class="account__global-img"
                @click="setLang(lang.key)"
              >
                <!-- @click="store.dispatch(`useGlobalList/langaugeClick(${lang.key}, ${useSwitchLocalePath()}`)" -->
                <img :src="lang.icon" />
                <p :class="lang.isActive ? 'active' : ''" class="lang__text">
                  {{ lang.label }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gradient-line right menu__extra__line"></div>
    </section>

    <!-- mobile header -->
    <article class="mobile-header-wrapper">
      <section class="mobile-header">
        <!-- <router-link to="/" class="logo" @click="windowTopHandler"> -->
        <a
          href="https://www.risingx.co.kr/DashBoard"
          class="logo"
          @click="windowTopHandler"
        >
          <img :src="Logo" alt="" v-if="!isShow" :key="isShow" />
        </a>
        <!-- </router-link> -->

        <button class="hamburger-btn" @click="toggleContent()">
          <img
            :src="showContent ? Hamburger_ico : Hamburger_ico_active"
            alt=""
          />
        </button>
      </section>
    </article>

    <div
      v-if="!showContent"
      class="gradient-line mobile-header-line max-width"
    ></div>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineEmits, defineProps, onMounted } from "vue";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Logo from "@/assets/images/layouts/logo.svg";
import Referrals from "@/assets/images/layouts/sideBar/referrals.svg";
import ReferralsActive from "@/assets/images/layouts/sideBar/referrals_active.svg";
import Hamburger_ico from "@/assets/images/layouts/header/mobileHeader/hambugerActive.svg";
import Hamburger_ico_active from "@/assets/images/layouts/header/mobileHeader/hambugerInactive.svg";
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
const store = useStore();
const router = useRouter();
const onSwiper = (swiper) => {
  // console.log(swiper);
};
const onSlideChange = () => {
  console.log("slide change");
};
const { t, locale } = useI18n({ useScope: "global" });
// const storeType       = useUserStore().getUserInfo().store_type;
// const settingMenuData = computed(()=> store.getters['useMainMenuList/settingItems']);
const mainMenuData = computed(
  () => store.getters["useMainMenuList/mainMenuItems"]
);

console.log("mainMenuData", mainMenuData.value);

const mainMenuRef = computed(() =>
  mainMenuData.value.filter((ob) => ob.isActive)
);

const showToast = ref(false);
const referralActive = ref(false);
// const bannerList      = ref([]);
const globalMenu = computed(() => store.getters["useGlobalList/globalItems"]);
const globalImg = computed(
  () => globalMenu.value.find((list) => list.key == locale.value).icon
);

const props = defineProps({
  isShow: Boolean,
  foldingMenu: Boolean,
});

const showContent = ref(false);
const selectLang = ref(false);
const menuHover = ref({});
// const menuKeyArr     = computed(()=> settingMenuData.value.map(ob => ob.key).filter(ob => ob));
// menuKeyArr.value.forEach(ob => {
//     menuHover.value[ob] = false;
// });

const isFullScreen = computed(() => store.state.useFullScreen.isFullScreen);

const hoverHandler = (type, item) => {
  switch (type) {
    case "enter":
      menuHover.value[item.key] = true;
      break;
    case "leave":
      menuHover.value[item.key] = false;
      break;
  }
};

const emit = defineEmits(["openContent"]);
const toggleContent = () => {
  showContent.value = !showContent.value;

  emit("openContent", showContent.value);
};

const windowTopHandler = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
watch(mainMenuData, (newVal) => {
  // console.log('watch mainMenuData',mainMenuData);

  if (mainMenuData.value != newVal) {
    mainMenuRef.value = newVal.filter((ob) => ob.isActive);

    // console.log("changed menu", mainMenuRef.value);
  }
});

watch(
  () => props.isShow,
  (newVal) => {
    if (!newVal) {
      showContent.value = false;
    }
  }
);

const menuClickHandler = (item) => {
  // popupStore.openBetaPopup(false);
  // if(!item.beta) {
  //     popupStore.openBetaPopup(true);
  //     return;
  // }
  store.dispatch("usePopupList/openBetaPopup", false);
  if (!item.beta) {
    // popupStore.openBetaPopup(true);
    store.dispatch("usePopupList/openBetaPopup", true);
    return;
  }
  let path = item.route;
  let query = { menuName: item.key };

  console.log(query);

  // if(item.key === "store") {
  //     if(storeType === "0") {
  //         popupStore.openBetaPopup(true);
  //         return;
  //     }
  //     query = {menuName : 'store_dashboard'};
  // }
  // if(isMyStoreMenu.value) {
  //     path = '/dashboard'
  //     query = {menuName : 'dashboard'}
  // };
  // if(item.key === "settings") {
  //     if(isMyStoreMenu.value) {
  //         path = '/settings/dashboard'
  //         query = {menuName : 'settings', type: 'store', tab: 'store'}
  //     } else {
  //         path = '/settings/dashboard'
  //         query = {menuName : 'settings', type: 'user', tab: 'default'}
  //     }
  // }
  // mainMenuStore.setMenuStatus(item.key);
  store.dispatch("useMainMenuList/setMenuStatus", item.key);
  // const lang_code = useCookie('i18n_redirected').value;
  router.push({
    path: path,
    // // path : localePath(path, lang_code),
    query: query,
  });
};

// const isMyStoreMenu = computed(() => {
//     return useStoreList().isStorePage;
// });

// const selectReferrals = () => {
//     const userData = useUserStore().userData;
//     const origin = `${window.location.origin}`;

//     showToast.value = true;
//     setTimeout(() => {
//         showToast.value = false;
//     }, 2000);

//     navigator.clipboard.writeText(`${origin}/signup?referral=${userData.user_ref_id}`);
// };

// async function getBannerText() {
//     const {data, error} = await fetchBannerText();
//     if(error.value) {
//         error.value = null;
//         return;
//     }
//     bannerList.value = data.value.data;
// }

// await getBannerText();

function setLang(lang) {
  locale.value = lang;
  selectLang.value = false;
  store.commit("useGlobalList/changeLang", lang); // 쿠키 실시간 반영 x 로 state 로 언어감지
  store.dispatch("useGlobalList/langaugeClick", lang);
  store.commit("useMainMenuList/resetMenuItems");
  cookies.set("i18n_redirected", lang);
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/login/after/Header.scss";
@import "@/assets/scss/components/common/login/after/HeaderMediaquery.scss";
</style>
